import api from './api';
import { ApiResponse } from '@/utils/api-response.util';
import { ConnectionAccessItem } from '../types/access-control.types';

export interface PendingConnectionDto {
  id: number;
  clientId: number;
  status: 'pending';
  createdAt: string;
  name: string;
  surname: string | null;
  avatar: string | null;
  customPermissions: ConnectionAccessItem[] | null;
}

export const getPendingConnections = async (): Promise<PendingConnectionDto[]> => {
  const response = await api.get<ApiResponse<PendingConnectionDto[]>>('/user-connections/pending');
  return response.data.data;
};

export const acceptConnection = async (id: number): Promise<void> => {
  await api.put(`/user-connections/${id}/accept`);
};

export const rejectConnection = async (id: number): Promise<void> => {
  await api.put(`/user-connections/${id}/reject`);
};

export const requestConnection = async (expertId: number, access?: ConnectionAccessItem[] | null, comment?: string): Promise<void> => {
  const body: Record<string, unknown> = { expertId };
  if (access) body.access = access;
  if (comment?.trim()) body.comment = comment.trim();
  await api.post('/user-connections', body);
};
